export default "__VITE_ASSET__DSNexfSC__"